import React, { useState } from "react";
import { Briefcase, Plus, MapPin, Clock, FileText } from "lucide-react";

export default function Admin() {
  const [form, setForm] = useState({
    position: "",
    salary: "",
    experience: "",
    skills: "",
    jobType: "",
    location: "",
    description: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Vacancy Posted Successfully!");
    setForm({
      position: "",
      salary: "",
      experience: "",
      skills: "",
      jobType: "",
      location: "",
      description: "",
    });
  };

  return (
    <div className="admin-container">
      
      {/* Sidebar */}
      <aside className="sidebar">
        <h2 className="sidebar-title">Admin Panel</h2>

        <nav className="sidebar-nav">
          <button className="nav-item active">
            <Plus size={20} />
            <span>Post Vacancy</span>
          </button>
          
        </nav>
      </aside>

      {/* Form */}
      <main className="content">
        <div className="content-wrapper">
          <h1 className="title">Post New Vacancy</h1>
          <p className="subtitle">Fill the details below</p>

          <form className="vacancy-form" onSubmit={handleSubmit}>
            
            <div className="form-row">
              <div className="form-group">
                <label><Briefcase size={16} /> Position *</label>
                <input 
                  type="text"
                  name="position"
                  required
                  value={form.position}
                  onChange={handleChange}
                  placeholder="e.g. React Developer"
                />
              </div>

              <div className="form-group">
                <label>₹ Salary</label>
                <input 
                  type="text"
                  name="salary"
                  value={form.salary}
                  onChange={handleChange}
                  placeholder="e.g. ₹30,000 - ₹50,000"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label><Clock size={16} /> Experience</label>
                <input 
                  type="text"
                  name="experience"
                  value={form.experience}
                  onChange={handleChange}
                  placeholder="e.g. 1-2 years"
                />
              </div>

              <div className="form-group">
                <label>Job Type</label>
                <select name="jobType" value={form.jobType} onChange={handleChange}>
                  <option value="">Select job type</option>
                  <option value="Full Time">Full Time</option>
                  <option value="Part Time">Part Time</option>
                  <option value="Internship">Internship</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label><MapPin size={16} /> Location</label>
                <input 
                  type="text"
                  name="location"
                  value={form.location}
                  onChange={handleChange}
                  placeholder="e.g. Location"
                />
              </div>

              <div className="form-group">
                <label>Skills</label>
                <input
                  type="text"
                  name="skills"
                  value={form.skills}
                  onChange={handleChange}
                  placeholder="e.g. React, Node.js"
                />
              </div>
            </div>

            <div className="form-group full-width">
              <label><FileText size={16} /> Description</label>
              <textarea
                name="description"
                rows="5"
                value={form.description}
                onChange={handleChange}
                placeholder="Write job description..."
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">
              <Plus size={20} /> Post Vacancy
            </button>
          </form>
        </div>
      </main>

      <style jsx>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }

        .admin-container {
          display: flex;
          height: 100vh;
          background: #f5f6fa;
          font-family: "Segoe UI", sans-serif;
        }

        /* Sidebar */
        .sidebar {
          width: 240px;
          background: linear-gradient(#83ce55 5%,#42aa73 25%,#03708b,#057399);
          color:#fff;
          text-align:center;
          border-right: 1px solid #e0e0e0;
          padding: 25px 20px;
        }

        .sidebar-title {
          font-size: 30px;
          font-weight: 700;
          margin-bottom: 30px;
          color: #fff;
        }

        .nav-item {
          width: 100%;
          padding: 12px 14px;
          display: flex;
          align-items: center;
          gap: 10px;
          background: #f1f1f1;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          color: #444;
          font-size: 15px;
          margin-top:10px;
        }

        .nav-item.active {
          background: #2563eb;
          color: #fff;
        }

        /* Content area */
        .content {
          flex: 1;
          padding: 40px;
          overflow-y: auto;
        }

        .title {
          font-size: 28px;
          font-weight: 700;
          color: #222;
          margin-bottom: 5px;
        }

        .subtitle {
          color: #666;
          margin-bottom: 25px;
        }

        /* Form */
        .vacancy-form {
          background: #fff;
          padding: 30px;
          border-radius: 10px;
          border: 1px solid #e5e7eb;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-group.full-width {
          grid-column: 1 / -1;
        }

        .form-group label {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          margin-bottom: 6px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .form-group input,
        .form-group select,
        .form-group textarea {
          padding: 12px;
          border: 1px solid #ccc;
          border-radius: 6px;
          font-size: 15px;
          background: #fafafa;
        }

        .submit-btn {
          width: 100%;
          padding: 14px;
          background: #2563eb;
          color: #fff;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          margin-top:5px;
        }

        /* Mobile */
        @media (max-width: 768px) {
          .form-row { grid-template-columns: 1fr; }
          .content { padding: 20px; }
        }
      `}</style>
    </div>
  );
}
